import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de31a5de"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import BaseButton from '@/components/Buttons/BaseButton.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { FreeMode } from 'swiper/modules'
import { useYandexMetrika } from 'yandex-metrika-vue3'
import { METRIKA_TARGET_SERIES_BTN } from '@/helpers/globalVars'


export default /*#__PURE__*/_defineComponent({
  __name: 'SeriesSlider',
  props: {
    seriesList: {}
  },
  setup(__props: any) {

const props = __props

const route = useRoute()
const router = useRouter()
const mediaId = computed(() => route.params.media as string)

const onSwiper = (swiper) => {
  swiper.slideTo(props.seriesList.indexOf(mediaId.value as string))
}

const onSelectSeries = (id: string) => {
  try {
    const yandexMetrika = useYandexMetrika()
    yandexMetrika.reachGoal(METRIKA_TARGET_SERIES_BTN)
  } catch (e) {
    console.log('Metrika error', e)
  }
  router.push({ name: 'project-player', params: { media: id } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    onInit: onSwiper,
    slidesPerView: 'auto',
    "space-between": 10,
    class: "series__slider",
    freeMode: true,
    modules: [_unref(FreeMode)],
    "centered-slides": true
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seriesList, (series, index) => {
        return (_openBlock(), _createBlock(_unref(SwiperSlide), {
          key: series,
          class: "slide"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: ($event: any) => (onSelectSeries(series)),
              class: "slide__link"
            }, [
              _createVNode(BaseButton, {
                class: "uppercase",
                bg: "none",
                border: series === mediaId.value ? 'gradient' : 'default'
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Серия " + _toDisplayString(index + 1), 1)
                ]),
                _: 2
              }, 1032, ["border"])
            ], 8, _hoisted_1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["modules"]))
}
}

})